export function openLinkInANewTab(url: string) {
  window.open(url, '_blank');
}
